
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFAF00","d":"M25.062 2.375c.311 0 .563.252.563.563v7.5c0 .31-.252.562-.563.562h-7.5a.563.563 0 01-.562-.562v-.47c0-.31.252-.562.562-.562h5.358A10.028 10.028 0 0014 3.97C8.437 3.969 3.969 8.48 3.969 14c0 5.563 4.512 10.031 10.031 10.031a9.992 9.992 0 006.708-2.572c.222-.2.562-.19.773.022l.331.331c.229.229.217.6-.022.817A11.582 11.582 0 0114 25.625c-6.414 0-11.615-5.195-11.625-11.606C2.365 7.625 7.57 2.395 13.963 2.375A11.619 11.619 0 0124.03 8.123V2.938c0-.311.252-.563.563-.563zm-10.734 4.5c.31 0 .563.253.563.563v6.857l3.304 2.405a.562.562 0 01.122.788l-.384.53a.566.566 0 01-.788.121l-3.806-2.766a.566.566 0 01-.23-.454V7.438c0-.31.253-.563.563-.563z"}})])
          )
        }
      }
    